import { Box } from '@mui/material'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import Bugsnag from '@bugsnag/js'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { downloadIndividualAnnualReport } from 'services/api/modules/payroll/payroll-yearly-report'
import AdxButton from 'components/custom/AdxButton'
import { downloadResponseFile } from 'services/helper/fileDownload'

const PayrollDownloadAnnualReport = () => {
  const { year, form } = useParams()
  const navigate = useNavigate()
  const [errorModal, setErrorModal] = useState({ error: null, status: false })

  const { refetch } = useQuery(
    ['downloadIndividualReport'],
    () =>
      downloadIndividualAnnualReport({
        year: parseInt(year),
        form,
      }),
    {
      onSuccess: (res) => {
        downloadResponseFile(res, {
          fileName: `${form}_${year}_annual_report`,
          contentType: res.headers['content-type'],
          successMessage: 'Annual report downloaded.',
        })
        navigate('/')
      },
      onError: (err) => {
        Bugsnag.notify(err)
        setErrorModal({ error: err, status: true })
      },
    }
  )
  const handleDownload = () => {
    refetch()
  }

  const handleCloseError = () => {
    setErrorModal({ error: null, status: false })
  }

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundColor: 'gray-background.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <AdxButton variant={'contained'} onClick={handleDownload}>
        Download report
      </AdxButton>
      <AdxInfoModal
        open={errorModal?.status}
        handleClose={handleCloseError}
        muiIcon="error"
        iconColor="error.main"
        title="Ops. Something went wrong"
        subtitle="If you think this is a mistake, please contact your admin."
        footerButtons
        firstBtnLabel={'Ok'}
        firstBtnHandle={handleCloseError}
      ></AdxInfoModal>
    </Box>
  )
}

export default PayrollDownloadAnnualReport
